<div class="container my-4">
    <div class="row">
        <div class="col-12 commission_report">
            <div class="title_header_bar">
                Shop Orders Report
            </div>
        </div>
    </div>
    <div class="card card_content">
        <form [formGroup]="ShopOrderReportForm">
            <div class="row">
                <div class="col-12 ml-3">
                    <!-- <button class="btn btn-secondary" (click)="Reset()">
                        <i class="fa fa-refresh"></i> Refresh
                    </button> -->
                    <app-button (refreshClicked)="Reset()"></app-button>

                </div>
                <div class="col-xl-1"></div>
                <div class="col-xl-10">
                    <div class="row">
                        <div class="col-xl-6 mt-4">
                            <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                                <mat-label>Start Date</mat-label>
                                <input readonly matInput appInputtext [matDatepicker]="startDate"
                                    formControlName="startDate" selectable="isSelectable(date,type)" id="startDate"
                                    autocomplete="off" placeholder="Select From Date" class="custom-input-border"
                                    specialIsAlphaNumeric (click)="openStartDateDatePicker()">
                                <mat-datepicker-toggle matSuffix [for]="startDate" style="color:black;">
                                    <button mat-icon-button>
                                        <mat-icon>event</mat-icon>
                                    </button>
                                </mat-datepicker-toggle>
                                <mat-datepicker #startDate></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="col-xl-6 mt-4">
                            <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                                <mat-label>End Date</mat-label>
                                <input readonly matInput appInputtext [matDatepicker]="endDate"
                                    formControlName="endDate" selectable="isSelectable(date,type)" id="endDate"
                                    autocomplete="off" [min]="toMinDate" [max]="toMaxDate" placeholder="Select To Date"
                                    class="custom-input-border" specialIsAlphaNumeric (click)="openEndDateDatePicker()">
                                <mat-datepicker-toggle matSuffix [for]="endDate" style="color:black;">
                                    <button mat-icon-button>
                                        <mat-icon>event</mat-icon>
                                    </button>
                                </mat-datepicker-toggle>
                                <mat-datepicker #endDate></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="col-xl-6 mt-3">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Order Status</mat-label>
                                <mat-select class="scrollbarcs" formControlName="orderStatus"
                                    placeholder="Please select Order Status" (selectionChange)="checkvalidation()" >
                                    <mat-select-filter [displayMember]="'value'" [array]="orderStatusList"
                                        (filteredReturn)="filteredList1 = $event"></mat-select-filter>
                                    <mat-option *ngFor="let item of filteredList1" [value]="item.key"
                                        style="overflow-y: scroll !important;">
                                        {{item.value}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-xl-6 mt-3">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Line Item Status</mat-label>
                                <mat-select class="scrollbarcs" formControlName="lineItemStatus"
                                    placeholder="Please select Line Item Status" (selectionChange)="checkvalidation()"> 
                                    <mat-select-filter [displayMember]="'value'" [array]="lineItemStatusList"
                                        (filteredReturn)="filteredList2 = $event"></mat-select-filter>
                                    <mat-option *ngFor="let item of filteredList2" [value]="item.key"
                                        style="overflow-y: scroll !important;">
                                        {{item.value}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-xl-6"></div>
                        <div class="col-12 mt-5 d-flex justify-content-center">
                            <button class="btn btn-primary mr-3" (click)="generateExcel()">
                                <i class="fa fa-file-excel mr-1"></i> Generate Excel
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col-xl-1"></div>

            </div>
        </form>

    </div>
</div>